export const FIELD_INFO = {
    name: {
        minLength: 1,
        maxLength: 200,
    },
    description: {
        minLength: 1,
        maxLength: 5000,
    },
    maxImages: 8,
    maxImagesLevel: 'product',
} as const
